/* Yeat-style behaviour: banner slider, menu panel (open/close, expand/collapse, live search), side dots,
   and a live cart total/count with a bump when the count goes up. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---------- banner slider ---------- */
  function initSlider(root) {
    var slides = $$('[data-yt-slide]', root);
    if (slides.length < 2) return;
    var bars = $$('.yt-banner__bars i', root);
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        $$('a', s).forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      });
      // each bar fills over the slide's time; finished bars stay full. The bar's animationend advances the slide.
      bars.forEach(function (b, k) {
        b.classList.remove('is-active', 'is-done');
        if (k < i) b.classList.add('is-done');
        else if (k === i) { void b.offsetWidth; b.classList.add('is-active'); }
      });
    }
    function stop() { root.classList.add('is-paused'); }
    function start() { root.classList.remove('is-paused'); }
    bars.forEach(function (b) { b.addEventListener('animationend', function () { if (b.classList.contains('is-active')) show(i + 1); }); });
    var prev = $('[data-yt-prev]', root), next = $('[data-yt-next]', root);
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
    var tx = null;
    root.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (tx !== null) { var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1)); }
      tx = null; start();
    });
    show(0);
  }

  /* ---------- money + cart ---------- */
  function money(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || 'Dhs. {{amount}}';
    var n = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount\s*\}\}/, n)
              .replace(/\{\{\s*[a-z_]+\s*\}\}/, n);
  }
  var lastCount = null;
  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-yt-total]').forEach(function (el) { el.textContent = money(c.total_price); });
      $$('[data-yt-count]').forEach(function (el) { el.textContent = c.item_count; });
      if (lastCount !== null && c.item_count > lastCount && !reduce) {
        $$('.yt-cart').forEach(function (el) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
      }
      lastCount = c.item_count;
    }).catch(function () {});
  }
  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(function (list) {
        if (list.getEntries().some(function (e) { return /\/cart\/(add|change|update|clear)/.test(e.name); })) setTimeout(refreshCart, 150);
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }

  /* ---------- menu panel ---------- */
  function initMenu() {
    var menu = $('[data-yt-menu]'), scrim = $('[data-yt-scrim]'), openBtn = $('[data-yt-menu-open]');
    if (!menu || !scrim || !openBtn) return;
    document.body.appendChild(scrim); document.body.appendChild(menu); // outside the transformed page wrapper so it stacks above everything
    var closeBtn = $('[data-yt-menu-close]', menu), input = $('[data-yt-msearch]', menu), box = $('[data-yt-suggest]', menu);
    function setOpen(on) {
      menu.classList.toggle('is-open', on); scrim.classList.toggle('is-open', on);
      openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.documentElement.style.overflow = on ? 'hidden' : '';
      document.documentElement.classList.toggle('yt-menu-open', on);
      if (on) { menu.focus({ preventScroll: true }); } else { openBtn.focus({ preventScroll: true }); box.hidden = true; }
    }
    openBtn.addEventListener('click', function () { setOpen(true); });
    closeBtn.addEventListener('click', function () { setOpen(false); });
    scrim.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (!menu.classList.contains('is-open')) return;
      if (e.key === 'Escape') { setOpen(false); return; }
      if (e.key === 'Tab') {
        var f = $$('a[href],button,input', menu).filter(function (x) { return x.offsetParent !== null && x.tabIndex !== -1; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === menu)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // parents only expand / collapse (they never navigate)
    $$('.yt-menu__mi--label', menu).forEach(function (btn) {
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var on = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        sub.classList.toggle('is-open', on);
        $$('a', sub).forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      });
    });

    // search with suggestions
    var POPULAR = ['Hoodie', 'T-shirt', 'Jacket', 'Jeans', 'Sneakers', 'Jersey'];
    var timer = null, active = -1;
    function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }
    function items() { return $$('.yt-suggest__item', box); }
    function setActive(k) { var it = items(); it.forEach(function (x, j) { x.classList.toggle('is-active', j === k); }); active = k; }
    function showPopular() {
      box.textContent = ''; box.appendChild(el('p', 'yt-suggest__h', 'Popular searches'));
      POPULAR.forEach(function (w) {
        var a = el('a', 'yt-suggest__item yt-suggest__item--text'); a.href = '/search?type=product&q=' + encodeURIComponent(w);
        a.appendChild(el('span', 'yt-suggest__t', w)); box.appendChild(a);
      });
      box.hidden = false; active = -1;
    }
    function render(q, products) {
      box.textContent = '';
      if (!products.length) { box.appendChild(el('p', 'yt-suggest__h', 'No matches')); }
      products.forEach(function (p) {
        var a = el('a', 'yt-suggest__item'); a.href = p.url;
        var img = el('img'); img.alt = ''; img.width = 52; img.height = 64; img.loading = 'lazy';
        if (p.image) img.src = p.image; a.appendChild(img);
        a.appendChild(el('span', 'yt-suggest__t', p.title));
        a.appendChild(el('span', 'yt-suggest__p', money(Math.round(parseFloat(p.price) * 100))));
        box.appendChild(a);
      });
      var all = el('a', 'yt-suggest__all', 'View all results'); all.href = '/search?type=product&q=' + encodeURIComponent(q); box.appendChild(all);
      box.hidden = false; active = -1;
    }
    function query(q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) { if (input.value.trim() === q) render(q, (d.resources && d.resources.results && d.resources.results.products) || []); })
        .catch(function () { box.hidden = true; });
    }
    input.addEventListener('focus', function () { if (!input.value.trim()) showPopular(); });
    input.addEventListener('input', function () {
      var q = input.value.trim(); clearTimeout(timer);
      if (!q) { showPopular(); return; }
      timer = setTimeout(function () { query(q); }, 200);
    });
    input.addEventListener('keydown', function (e) {
      var it = items(); if (!it.length || box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive((active + 1) % it.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((active - 1 + it.length) % it.length); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); it[active].click(); }
    });
  }

  /* ---------- side dots ---------- */
  function initJumps() {
    var rows = $$('.yt-hero, .yt-row[data-yt-jump]');
    if (rows.length < 3 || !('IntersectionObserver' in window)) return;
    var nav = document.createElement('nav'); nav.className = 'yt-jumps'; nav.setAttribute('aria-label', 'Jump to section');
    var links = rows.map(function (r, k) {
      if (!r.id) r.id = 'yt-sec-' + k;
      var a = document.createElement('a'); a.href = '#' + r.id; a.setAttribute('aria-label', r.getAttribute('data-yt-jump') || 'Top');
      a.className = 'js-no-transition';
      a.addEventListener('click', function (e) { e.preventDefault(); r.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); });
      nav.appendChild(a); return a;
    });
    document.body.appendChild(nav);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { var k = rows.indexOf(en.target); links.forEach(function (a, j) { a.classList.toggle('is-active', j === k); }); } });
    }, { rootMargin: '-40% 0px -50% 0px' });
    rows.forEach(function (r) { io.observe(r); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-yt-slider]').forEach(initSlider);
    initMenu(); initJumps(); refreshCart();
  });
})();